// src/pages/CasinoTeenPattiOneDayViewPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { getAccessToken } from '../store/actions/auth';
import API_BASE_URL from '../config/baseUrl';
const ODDS_API_URL = "https://oddsapi.247idhub.com";

// Card back placeholder
const cardBackUrl = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 140'%3E%3Crect width='100' height='140' fill='%23dc2626' rx='5'/%3E%3Crect x='5' y='5' width='90' height='130' fill='white' rx='3'/%3E%3Crect x='10' y='10' width='80' height='120' fill='%23dc2626' rx='2'/%3E%3C/svg%3E";

// ─── Card image (raw code, no suit-swap) ──────────────────────────────────
const getCardImage = (cardCode) => {
  if (!cardCode || cardCode === '1' || cardCode.trim() === '') {
    return 'https://versionobj.ecoassetsservice.com/v14/static/front/img/cards/1.jpg';
  }
  const code = cardCode.trim();
  // Card code (HH/SS/DD/CC) image filename se seedha match karta hai — koi suit-swap NAHI (pehle HH→SS→DD→HH swap tha, jisse admin me TV se alag suit dikhte the).
  const mapped = code;
  return `https://versionobj.ecoassetsservice.com/v14/static/front/img/cards/${mapped}.jpg`;
};

// Result cards: "9HH,AHH,6SS,9CC,4DD,QDD" → A = [0,2,4], B = [1,3,5]
const parseCardsFromResult = (resultItem) => {
  if (!resultItem || !resultItem.cards) {
    return { playerA: ['1', '1', '1'], playerB: ['1', '1', '1'] };
  }
  const c = resultItem.cards.split(',');
  return {
    playerA: [(c[0] || '1').trim(), (c[2] || '1').trim(), (c[4] || '1').trim()],
    playerB: [(c[1] || '1').trim(), (c[3] || '1').trim(), (c[5] || '1').trim()],
  };
};

// Flip Card Component
const FlipCard = ({ isFlipped, cardValue }) => {
  return (
    <div className="w-6 h-10 sm:w-8 sm:h-12 md:w-10 md:h-16 lg:w-12 lg:h-20 xl:w-12 xl:h-16 2xl:w-14 2xl:h-20 perspective-1000">
      <div 
        className={`relative w-full h-full transition-transform duration-500 transform-style-3d ${isFlipped ? 'rotate-y-180' : ''}`}
        style={{ transformStyle: 'preserve-3d' }}
      >
        {/* Front (Card Back) */}
        <div 
          className="absolute w-full h-full backface-hidden"
          style={{ backfaceVisibility: 'hidden' }}
        >
          <img src={cardBackUrl} alt="card back" className="w-full h-full rounded" />
        </div>
        
        {/* Back (Card Front) */}
        <div 
          className="absolute w-full h-full backface-hidden rotate-y-180"
          style={{ 
            backfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)'
          }}
        >
          <img 
            src={cardValue || cardBackUrl} 
            alt="card front" 
            className="w-full h-full rounded" 
          />
        </div>
      </div>
    </div>
  );
};

// Left Arrow Icon
const LeftArrowIcon = () => (
  <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
    <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
  </svg>
);

// Right Arrow Icon
const RightArrowIcon = () => (
  <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
    <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
  </svg>
);

const CasinoTeenPattiOneDayViewPage = () => {
  const navigate = useNavigate();
  const { tableId, gameName } = useParams();
  
  const [loading, setLoading] = useState(true);
  const [currentRoundId, setCurrentRoundId] = useState('');
  const [gameData, setGameData] = useState(null);
  const [resultsHistory, setResultsHistory] = useState([]);
  const [liability, setLiability] = useState({});
  const [nonDeclareBets, setNonDeclareBets] = useState([]);
  const [completedGames, setCompletedGames] = useState([]);
  const [totalPnl, setTotalPnl] = useState(0);
  const [timer, setTimer] = useState(0);
  const [selectedResult, setSelectedResult] = useState(null);
  
  // Pagination states
  const [nonDeclareCurrentPage, setNonDeclareCurrentPage] = useState(1);
  const [completedCurrentPage, setCompletedCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Get today's date
  const getTodayDate = () => {
    const today = new Date();
    return today.getFullYear() + '-' + 
           String(today.getMonth() + 1).padStart(2, '0') + '-' + 
           String(today.getDate()).padStart(2, '0');
  };

  // Fetch game data (1 second interval)
  const fetchGameData = async () => {
    try {
      const response = await axios.get(`${ODDS_API_URL}/betfair_api/casino/data/meta-Teen`);
      if (response.data && response.data.t1 && response.data.t1[0]) {
        setGameData(response.data);
        setCurrentRoundId(response.data.t1[0].mid);
        setTimer(response.data.t1[0].autotime || 0);
      }
    } catch (err) {
      console.error('Error fetching game data:', err);
    }
  };

  // Fetch results history (1 second interval)
  const fetchResultsHistory = async () => {
    try {
      const response = await axios.get(`${ODDS_API_URL}/betfair_api/casino/result/meta-Teen`);
      if (response.data) {
        setResultsHistory(response.data.slice(0, 10));
      }
    } catch (err) {
      console.error('Error fetching results:', err);
    }
  };

  // Fetch liability
  const fetchLiability = async (roundId) => {
    if (!roundId) return;
    try {
      const token = getAccessToken();
      const response = await axios.post(
        `${API_BASE_URL}/casino/liability`,
        { roundId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status && response.data.data) {
        const liabilityMap = {};
        response.data.data.forEach(item => {
          liabilityMap[item.sid] = item.liability;
        });
        setLiability(liabilityMap);
      }
    } catch (err) {
      console.error('Error fetching liability:', err);
    }
  };

  // Fetch non-declare bets
  const fetchNonDeclareBets = async () => {
    try {
      const token = getAccessToken();
      const today = getTodayDate();
      const response = await axios.post(
        `${API_BASE_URL}/casino/casino-bet-list-admin`,
        {
          tableId: tableId || "61",
          fromDate: today,
          toDate: today,
          userId: "",
          isGameCompleted: false,
          sportId: 5015
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status && response.data.data) {
        setNonDeclareBets(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching non-declare bets:', err);
    }
  };

  // Fetch completed games
  const fetchCompletedGames = async () => {
    try {
      const token = getAccessToken();
      const response = await axios.post(
        `${API_BASE_URL}/ant-pro/get-casino-bets-by-tableid`,
        { tableId: tableId || "61", isActive: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status && response.data.data) {
        setCompletedGames(response.data.data);
        const total = response.data.data.reduce((sum, game) => sum + (game.pnl || 0), 0);
        setTotalPnl(total);
      }
    } catch (err) {
      console.error('Error fetching completed games:', err);
    }
  };

  // Initial load
  useEffect(() => {
    const initLoad = async () => {
      setLoading(true);
      await Promise.all([
        fetchGameData(),
        fetchResultsHistory(),
        fetchNonDeclareBets(),
        fetchCompletedGames()
      ]);
      setLoading(false);
    };
    initLoad();
  }, [tableId]);

  // Fetch liability when roundId changes
  useEffect(() => {
    if (currentRoundId) {
      fetchLiability(currentRoundId);
    }
  }, [currentRoundId]);

  // Set up 1-second polling
  useEffect(() => {
    const interval = setInterval(() => {
      fetchGameData();
      fetchResultsHistory();
      if (currentRoundId) {
        fetchLiability(currentRoundId);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentRoundId]);

  // Get player rates and liability
  const getPlayerData = (playerId) => {
    if (!gameData || !gameData.t1) return { rate: '0', liability: 0, gstatus: 'ACTIVE' };
    const player = gameData.t1.find(p => p.sectionId === playerId);
    return {
      rate: player?.b1 || '0',
      liability: liability[playerId] || 0,
      gstatus: player?.gstatus || 'ACTIVE'
    };
  };

  const playerAData = getPlayerData('1');
  const playerBData = getPlayerData('2');

  // Get winner letter (A or B)
  const getWinnerLetter = (result) => {
    if (result === '1') return 'A';
    if (result === '2') return 'B';
    return result;
  };

  // Pagination for Non-Declare Bets
  const nonDeclareTotal = nonDeclareBets.length;
  const nonDeclareTotalPages = Math.ceil(nonDeclareTotal / itemsPerPage);
  const nonDeclareStart = (nonDeclareCurrentPage - 1) * itemsPerPage;
  const nonDeclareEnd = nonDeclareStart + itemsPerPage;
  const currentNonDeclareBets = nonDeclareBets.slice(nonDeclareStart, nonDeclareEnd);

  // Pagination for Completed Games
  const completedTotal = completedGames.length;
  const completedTotalPages = Math.ceil(completedTotal / itemsPerPage);
  const completedStart = (completedCurrentPage - 1) * itemsPerPage;
  const completedEnd = completedStart + itemsPerPage;
  const currentCompletedGames = completedGames.slice(completedStart, completedEnd);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {selectedResult && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={() => setSelectedResult(null)}>
          <div className="bg-white rounded-lg shadow-xl w-80 max-w-full mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <div className="bg-gray-700 px-4 py-3 flex justify-between items-center">
              <span className="text-white font-semibold">Result Details</span>
              <button onClick={() => setSelectedResult(null)} className="text-white text-xl leading-none">&times;</button>
            </div>
            <div className="p-4">
              <p className="text-sm text-gray-600 mb-1"><span className="font-semibold">Round ID:</span> {selectedResult.mid}</p>
              <p className="text-sm text-gray-600 mb-3"><span className="font-semibold">Winner:</span> Player {getWinnerLetter(selectedResult.win)}</p>
              {(() => {
                const cards = parseCardsFromResult(selectedResult);
                return (
                  <>
                    <div className="mb-3">
                      <div className="text-sm font-semibold mb-1 text-gray-700">Player A Cards</div>
                      <div className="flex gap-2 justify-center">
                        {cards.playerA.map((code, idx) => (
                          <img key={idx} src={getCardImage(code)} alt={`A card ${idx + 1}`} className="w-16 rounded shadow-md" style={{ height: '90px', objectFit: 'contain' }}
                            onError={(e) => { e.target.onerror = null; e.target.src = 'https://versionobj.ecoassetsservice.com/v14/static/front/img/cards/1.jpg'; }}
                          />
                        ))}
                      </div>
                    </div>
                    <div className="mb-2">
                      <div className="text-sm font-semibold mb-1 text-gray-700">Player B Cards</div>
                      <div className="flex gap-2 justify-center">
                        {cards.playerB.map((code, idx) => (
                          <img key={idx} src={getCardImage(code)} alt={`B card ${idx + 1}`} className="w-16 rounded shadow-md" style={{ height: '90px', objectFit: 'contain' }}
                            onError={(e) => { e.target.onerror = null; e.target.src = 'https://versionobj.ecoassetsservice.com/v14/static/front/img/cards/1.jpg'; }}
                          />
                        ))}
                      </div>
                    </div>
                  </>
                );
              })()}
              {selectedResult.newdesc && (
                <p className="text-xs text-gray-500 mt-3 text-center whitespace-pre-wrap">{selectedResult.newdesc.replace(/[#~]/g, '\n')}</p>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Main Card */}
      <div className="bg-white rounded shadow border border-gray-200 mb-4">
        {/* Header */}
        <div className="bg-gray-600 px-5 py-3 flex items-center justify-between">
          <span className="text-xl text-white font-normal">
            {decodeURIComponent(gameName || 'Teenpatti onday')}
          </span>
          <button 
            onClick={() => navigate(-1)}
            className="bg-blue-500 text-white px-4 py-2 hover:bg-blue-600"
          >
            Back
          </button>
        </div>

        <div className="p-4">
          {/* Video and Odds Section */}
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
            {/* Left Side - Video & Cards */}
            <div className="xl:col-span-7">
              {/* Match ID Bar */}
              <div className="bg-gray-700 px-3 py-2 flex justify-between items-center text-white mb-2">
                <span>Match ID: {currentRoundId}</span>
                <span>{timer}</span>
              </div>

              {/* Casino Video */}
              <div className="relative bg-black" style={{ height: '300px' }}>
                <iframe
                  title="Casino Video"
                  className="w-full h-full"
                  src="https://casino.loki7exch.com/route/?id=3031"
                />
                
                {/* Cards Overlay ─── live from gameData.t1[0] */}
                <div className="absolute top-2 left-2 sm:top-4 sm:left-4">
                  {(() => {
                    const row = gameData?.t1?.[0] || {};
                    const pick = (k) => row[k] || row[k.toUpperCase()] || row[k.toLowerCase()] || '';
                    const isLive = (code) => !!code && code.trim() !== '' && code.trim() !== '1';
                    const aCards = [pick('c1'), pick('c2'), pick('c3')];
                    const bCards = [pick('c4'), pick('c5'), pick('c6')];
                    return (
                      <>
                        {/* Player A */}
                        <div className="mb-4 sm:mb-6">
                          <div className="text-white text-sm font-bold mb-2">PLAYER A</div>
                          <div className="flex gap-1 sm:gap-2">
                            {aCards.map((code, i) => (
                              <FlipCard key={i} isFlipped={isLive(code)} cardValue={isLive(code) ? getCardImage(code) : undefined} />
                            ))}
                          </div>
                        </div>
                        {/* Player B */}
                        <div>
                          <div className="text-white text-sm font-bold mb-2">PLAYER B</div>
                          <div className="flex gap-1 sm:gap-2">
                            {bCards.map((code, i) => (
                              <FlipCard key={i} isFlipped={isLive(code)} cardValue={isLive(code) ? getCardImage(code) : undefined} />
                            ))}
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>

              {/* Last 10 Winners ─── click to see cards */}
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <span>Last 10 winners:</span>
                {resultsHistory.map((item, idx) => (
                  <span 
                    key={idx}
                    className="inline-block bg-blue-500 text-white px-3 py-1 text-sm cursor-pointer hover:bg-blue-600 transition-colors"
                    style={{ borderRadius: 0 }}
                    onClick={() => setSelectedResult(item)}
                    title="Click to see cards"
                  >
                    {getWinnerLetter(item.result)}
                  </span>
                ))}
              </div>
            </div>

            {/* Right Side - Player Rates Table */}
            <div className="xl:col-span-5">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border border-gray-300 p-2 text-left">Player Name</th>
                      <th className="border border-gray-300 p-2 text-center">Back</th>
                      <th className="border border-gray-300 p-2 text-center">Lay</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <p>Player A</p>
                          <p className="font-bold text-black">
                            {playerAData.liability.toFixed(2)}
                          </p>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <span>0.00</span>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <span>0.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <p>Player B</p>
                          <p className="font-bold text-black">
                            {playerBData.liability.toFixed(2)}
                          </p>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <span>0.00</span>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <span>0.00</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* NonDeclare Bets */}
      <div className="bg-white rounded shadow border border-gray-200 mb-4">
        <div className="bg-gray-600 px-5 py-3">
          <span className="text-xl text-white font-normal">
            NonDeclare Bets - [{nonDeclareTotal}]
          </span>
        </div>
        <div className="p-4">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 p-2 text-left">Client</th>
                  <th className="border border-gray-300 p-2 text-left">RoundId</th>
                  <th className="border border-gray-300 p-2 text-left">Player</th>
                  <th className="border border-gray-300 p-2 text-left">Winner</th>
                  <th className="border border-gray-300 p-2 text-left">Stake</th>
                  <th className="border border-gray-300 p-2 text-left">Profit</th>
                  <th className="border border-gray-300 p-2 text-left">Loss</th>
                </tr>
              </thead>
              <tbody>
                {currentNonDeclareBets.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="border border-gray-300 p-8 text-center text-gray-500">
                      No undeclared bets
                    </td>
                  </tr>
                ) : (
                  currentNonDeclareBets.map((bet, idx) => (
                    <tr key={idx}>
                      <td className="border border-gray-300 p-2">{bet.userId}</td>
                      <td className="border border-gray-300 p-2">{bet.marketId}</td>
                      <td className="border border-gray-300 p-2">{bet.selectionName}</td>
                      <td className="border border-gray-300 p-2">
                        <span className="text-green-600">Not Declear</span>
                      </td>
                      <td className="border border-gray-300 p-2">{bet.amount}</td>
                      <td className="border border-gray-300 p-2">{bet.profit || ''}</td>
                      <td className="border border-gray-300 p-2">{bet.loss || ''}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {nonDeclareTotalPages > 1 && (
            <div className="flex justify-end mt-3">
              <ul className="flex items-center gap-1">
                <li>
                  <button
                    onClick={() => setNonDeclareCurrentPage(p => Math.max(1, p - 1))}
                    disabled={nonDeclareCurrentPage === 1}
                    className="px-2 py-1 border border-gray-300 disabled:opacity-50"
                  >
                    <LeftArrowIcon />
                  </button>
                </li>
                <li>
                  <span className="px-3 py-1 bg-blue-500 text-white">
                    {nonDeclareCurrentPage}
                  </span>
                </li>
                <li>
                  <button
                    onClick={() => setNonDeclareCurrentPage(p => Math.min(nonDeclareTotalPages, p + 1))}
                    disabled={nonDeclareCurrentPage === nonDeclareTotalPages}
                    className="px-2 py-1 border border-gray-300 disabled:opacity-50"
                    >
                    <RightArrowIcon />
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Completed Games */}
      <div className="bg-white rounded shadow border border-gray-200">
        <div className="bg-gray-600 px-5 py-3 flex justify-between items-center">
          <span className="text-xl text-white font-normal">
            {decodeURIComponent(gameName || 'Teenpatti onday')}
          </span>
          <h1 className="text-white text-lg">
            Total: <span className={totalPnl >= 0 ? 'text-green-400' : 'text-red-400'}>
              {totalPnl.toFixed(2)}
            </span>
          </h1>
        </div>
        <div className="p-4">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 p-2 text-left">Game ID</th>
                  <th className="border border-gray-300 p-2 text-left">Started AT</th>
                  <th className="border border-gray-300 p-2 text-left">Plus/Minus</th>
                </tr>
              </thead>
              <tbody>
                {currentCompletedGames.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="border border-gray-300 p-8 text-center text-gray-500">
                      No completed games
                    </td>
                  </tr>
                ) : (
                  currentCompletedGames.map((game, idx) => (
                    <tr key={idx}>
                      <td className="border border-gray-300 p-2">{game.roundId}</td>
                      <td className="border border-gray-300 p-2">
                        <span>2026-01-22 03:56:21 AM</span>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <span className={game.pnl >= 0 ? 'text-green-600' : 'text-red-600'}>
                          {game.pnl.toFixed(2)}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {completedTotalPages > 1 && (
            <div className="flex justify-end mt-3">
              <ul className="flex items-center gap-1">
                <li>
                  <button
                    onClick={() => setCompletedCurrentPage(p => Math.max(1, p - 1))}
                    disabled={completedCurrentPage === 1}
                    className="px-2 py-1 border border-gray-300 disabled:opacity-50"
                  >
                    <LeftArrowIcon />
                  </button>
                </li>
                <li>
                  <span className="px-3 py-1 bg-blue-500 text-white">
                    {completedCurrentPage}
                  </span>
                </li>
                <li>
                  <button
                    onClick={() => setCompletedCurrentPage(p => Math.min(completedTotalPages, p + 1))}
                    disabled={completedCurrentPage === completedTotalPages}
                    className="px-2 py-1 border border-gray-300 disabled:opacity-50"
                  >
                    <RightArrowIcon />
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CasinoTeenPattiOneDayViewPage;
